import React, { ReactElement } from 'react'
import UploadFile from './UploadFile'
import useUploadHook from '../../hooks/UseUploadHook'
import { STATUS } from '../../enums/common'
import Spinner from '../Spinner'
import { IStepFileUploadProps } from '../../interfaces/Upload'

function StepFileUpload(props: IStepFileUploadProps): ReactElement {
  const {
    state,
    setState,
    validateFile,
    index,
    title,
    fileIndex,
    tooltip,
    className,
    loadingSpinnerClassName,
  } = props
  const { updateFiles, updateFileErrors, fIndex } = useUploadHook({
    index,
    setState,
    mainState: state,
    validateFile,
    fileIndex: fileIndex || 0,
  })
  const { file, fileAlerts, status, fileStatus } = state[index]

  if (status === STATUS.pending) {
    return (
      <div className={loadingSpinnerClassName}>
        <div className="relative pb3 pl3 mb3" key={index}>
          <Spinner small={true} />
        </div>
      </div>
    )
  }
  return (
    <div className={className}>
      <UploadFile
        title={title}
        file={file[fIndex]}
        index={index}
        fileAlert={fileAlerts[fIndex]}
        status={status}
        fileStatus={fileStatus[fIndex]}
        updateFiles={updateFiles}
        updateFileErrors={updateFileErrors}
        tooltip={tooltip}
      />
    </div>
  )
}

export default StepFileUpload
